import React from "react";
import classNames from "classnames";
import {SectionTilesProps} from "../../utils/SectionProps";
import { withTranslation } from "react-i18next";

import "./timeLine.scss";

const propTypes = {
  ...SectionTilesProps.types
};

const defaultProps = {
  ...SectionTilesProps.defaults
};

const TimeLine = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {
  const outerClasses = classNames(
    "testimonial section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "testimonial-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const tilesClasses = classNames("tiles-wrap", pushLeft && "push-left");

  const content = {
    "title": "Ecomspy's Road Map",
    "timeLine": [{
        "id": 0,
        "date": "June 1st, 2019",
        "detail": "Use of our software for our personal promotions."
      },
      {
        "id": 1,
        "date": "October 1st, 2020",
        "detail": "After having made millions of euros in influence marketing, we decided to offer the most complete ecommerce software to everyone."
      },
      {
        "id": 2,
        "date": "March 1st, 2021",
        "detail": "Added Influencer promotions on Snapchat."
      },
      {
        "id": 3,
        "date": "April 1st, 2021",
        "detail": "Added Snapchat Ads."
      },
      {
        "id": 4,
        "date": "May 1st, 2021",
        "detail": "Adding Facebook Ads."
      }
    ],
    lastItem : {
      text1 : "Next",
      text2 : "remains secret for the moment"
    }
  }

  const {t, id} = props;

  return (
    <section id={id} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <div className="center-content mb-16" style={{marginBottom: "50px"}}>
            <h2>{t(content.title)}</h2>
          </div>
          <div className={tilesClasses}>
            <div className="row example-centered">
              <div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2">
                <ul className="timeline timeline-centered">
                  {content &&
                    content.timeLine.map(item => {
                      return (
                        <li className="timeline-item" key={item.id}>
                          <div className="timeline-marker"></div>
                          <div className="timeline-content">
                            <p className="timeline-title">{t(item.date)}</p>
                            <h6>{t(item.detail)}</h6>
                          </div>
                        </li>
                      );
                    })}
                  <li className="timeline-item period">
                    <div className="timeline-info"></div>
                    <div className="timeline-marker"></div>
                    <div className="timeline-content">
                      <h6 className="timeline-title">{t(content.lastItem.text1)}</h6>
                      <p>{t(content.lastItem.text2)}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

TimeLine.propTypes = propTypes;
TimeLine.defaultProps = defaultProps;

export default withTranslation()(TimeLine);
/*
<li className="timeline-item period">
  <div className="timeline-info"></div>
  <div className="timeline-marker"></div>
  <div className="timeline-content">
    <h2 className="timeline-title">April 2016</h2>
  </div>
</li>
<li className="timeline-item">
  <div className="timeline-info">
    <span>April 02, 2016</span>
  </div>
  <div className="timeline-marker"></div>
  <div className="timeline-content">
    <h3 className="timeline-title">Event Title</h3>
    <p>
      Nullam vel sem. Nullam vel sem. Integer ante arcu,
      accumsan a, consectetuer eget, posuere ut, mauris. Donec
      orci lectus, aliquam ut, faucibus non, euismod id,
      nulla. Donec vitae sapien ut libero venenatis faucibus.
      ullam dictum felis eu pede mollis pretium. Pellentesque
      ut neque.{" "}
    </p>
  </div>
</li>
<li className="timeline-item">
  <div className="timeline-info">
    <span>April 28, 2016</span>
  </div>
  <div className="timeline-marker"></div>
  <div className="timeline-content">
    <h3 className="timeline-title">Event Title</h3>
    <p>
      Nullam vel sem. Nullam vel sem. Integer ante arcu,
      accumsan a, consectetuer eget, posuere ut, mauris. Donec
      orci lectus, aliquam ut, faucibus non, euismod id,
      nulla. Donec vitae sapien ut libero venenatis faucibus.
      ullam dictum felis eu pede mollis pretium. Pellentesque
      ut neque.{" "}
    </p>
  </div>
</li>
*/
